namespace RedBullMOBILE360.ESim {
    export interface ESIMExcelImportForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class ESIMExcelImportForm extends Serenity.PrefixedContext {
        static formKey = 'ESim.ESIMExcelImport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ESIMExcelImportForm.init)  {
                ESIMExcelImportForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(ESIMExcelImportForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
